const handleMobileFiltersTrigger = () => {
  $('.js-filter-trigger').on('click', function(event) {
    const $this = $(this);
    const mobileBreakpoint = 767;
    const isMobileBreakpoint = $(window).innerWidth() <= mobileBreakpoint;

    if (! isMobileBreakpoint) {
      return;
    }

    $this.toggleClass('is-active');

    $('.js-filters-container').slideToggle();

    event.preventDefault();
  });
}

handleMobileFiltersTrigger();
